import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export function AuthShell({ title, subtitle, children, footer, testId = "auth-shell" }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid={testId}>
      {/* Left visual */}
      <div className="hidden lg:block relative overflow-hidden bg-secondary">
        <img
          src="https://images.unsplash.com/photo-1486718448742-163732cd1544?auto=format&fit=crop&w=1600&q=80"
          alt="Globo"
          className="absolute inset-0 w-full h-full object-cover opacity-90"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/60 via-black/20 to-transparent" />
        <div className="relative h-full flex flex-col justify-between p-10 text-white">
          <Link to="/"><Logo /></Link>
          <div>
            <h2 className="font-display font-black tracking-tighter text-5xl leading-[0.95] max-w-md">
              Le Jeu de l'
              <span className="font-editorial italic font-normal text-white/95">Émergence</span>.
            </h2>
            <p className="mt-4 text-white/80 max-w-md text-sm leading-relaxed">
              Une plateforme sobre, exigeante, joyeuse — pensée pour révéler l'intelligence en jeu.
            </p>
          </div>
          <div className="text-xs uppercase tracking-[0.25em] text-white/60">CBC Global Holdings Ltd</div>
        </div>
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center p-6 sm:p-10">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8">
            <Link to="/"><Logo /></Link>
          </div>
          <h1 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl">{title}</h1>
          {subtitle && <p className="mt-2 text-muted-foreground">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-muted-foreground text-center">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
